import { render, staticRenderFns } from "./cdkey-code.vue?vue&type=template&id=645ec90b&scoped=true&"
import script from "./cdkey-code.vue?vue&type=script&lang=ts&"
export * from "./cdkey-code.vue?vue&type=script&lang=ts&"
import style0 from "./cdkey-code.vue?vue&type=style&index=0&id=645ec90b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ec90b",
  null
  
)

export default component.exports